import { useEffect } from "react";
import { useRecoilValue, useResetRecoilState } from "recoil";
import {
  documentFreeTagsState,
  isFormReselectedState,
} from "store/document/documentCommon";

interface UseResetDocStatesProps {
  step: number;
  resetDocStates: () => void;
}

const useResetDocStates = ({
  step,
  resetDocStates,
}: UseResetDocStatesProps) => {
  const isFormReselect = useRecoilValue(isFormReselectedState);
  const resetIsFormReselect = useResetRecoilState(isFormReselectedState);

  useEffect(() => {
    if (step === 0 && !isFormReselect) resetDocStates();
  }, [step, isFormReselect]);

  /* 자유태그 초기화 */
  const resetFreeTags = useResetRecoilState(documentFreeTagsState);

  useEffect(() => {
    return () => {
      resetIsFormReselect();
      resetFreeTags();
    };
  }, []);
};

export default useResetDocStates;
